/* AFTERHOURS — global interactions */
(function () {
  'use strict';

  /* Overtime palette crossfade:
     pages render light, then fade to the night palette if flagged */
  var target = document.body.getAttribute('data-mode-target');
  if (target === 'overtime') {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      document.body.setAttribute('data-mode', 'overtime');
    } else {
      requestAnimationFrame(function () {
        setTimeout(function () { document.body.setAttribute('data-mode', 'overtime'); }, 350);
      });
    }
  }

  /* Split hero title into gently staggered letters */
  document.querySelectorAll('[data-split]').forEach(function (el) {
    var text = el.textContent.trim();
    el.textContent = '';
    el.setAttribute('aria-label', text);
    text.split('').forEach(function (ch, i) {
      var s = document.createElement('span');
      s.className = 'l';
      s.textContent = ch === ' ' ? ' ' : ch;
      s.style.animationDelay = (0.05 * i + 0.2) + 's';
      s.setAttribute('aria-hidden', 'true');
      el.appendChild(s);
    });
  });

  /* Scroll reveals */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.16 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* Pinned hero scroll scene — drives --p (0 → 1) */
  var scene = document.querySelector('[data-hero-scene]');
  if (scene && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var sceneRaf = null;
    var updateScene = function () {
      var rect = scene.getBoundingClientRect();
      var total = scene.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      scene.style.setProperty('--p', p.toFixed(4));
      sceneRaf = null;
    };
    window.addEventListener('scroll', function () {
      if (!sceneRaf) sceneRaf = requestAnimationFrame(updateScene);
    }, { passive: true });
    updateScene();
  }

  /* Legacy hero (video) parallax */
  var heroMedia = document.querySelector('.hero-cinema .hero-media');
  var heroInner = document.querySelector('.hero-cinema .hero-inner');
  if (heroMedia) {
    var raf = null;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < window.innerHeight * 1.2) {
          heroMedia.style.transform = 'translateY(' + y * 0.25 + 'px)';
          if (heroInner) heroInner.style.opacity = Math.max(0, 1 - y / (window.innerHeight * 0.78));
        }
        raf = null;
      });
    }, { passive: true });
  }

  /* Pause hero video when offscreen */
  var heroVideo = document.querySelector('.hero-media video');
  if (heroVideo) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? heroVideo.play().catch(function(){}) : heroVideo.pause(); });
    }, { threshold: 0.05 }).observe(heroVideo);
  }

  /* Smooth handoff into Overtime: brief dim before navigating */
  document.querySelectorAll('[data-night-link]').forEach(function (link) {
    link.addEventListener('click', function (ev) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      ev.preventDefault();
      var veil = document.createElement('div');
      veil.style.cssText = 'position:fixed;inset:0;background:#262624;opacity:0;transition:opacity .5s ease;z-index:9999;pointer-events:none;';
      document.body.appendChild(veil);
      requestAnimationFrame(function () { veil.style.opacity = '0.94'; });
      setTimeout(function () { window.location.href = link.href; }, 480);
    });
  });

  /* Gender toggles — filter carousel cards / product grids */
  document.querySelectorAll('.gender-toggle').forEach(function (toggle) {
    var scope = toggle.closest('[data-division]') || document;
    toggle.addEventListener('click', function (ev) {
      var btn = ev.target.closest('button[data-gender]');
      if (!btn) return;
      toggle.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var g = btn.getAttribute('data-gender');
      var items = scope.querySelectorAll('[data-gender]');
      items.forEach(function (item) {
        if (item.tagName === 'BUTTON') return;
        var ig = item.getAttribute('data-gender');
        var show = (g === 'unisex') ? true : (ig === g || ig === 'unisex');
        item.style.display = show ? '' : 'none';
      });
    });
  });

  /* AJAX add-to-cart */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn.textContent;
      btn.textContent = 'Adding…'; btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (c) { c.textContent = cart.item_count; });
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
        })
        .catch(function () { btn.textContent = orig; btn.disabled = false; form.submit(); });
    });
  });
})();
